import { Handle, Position } from "@xyflow/react";
import {
  EnvelopeIcon,
  BoltIcon,
  ClockIcon,
  AdjustmentsHorizontalIcon,
} from "@heroicons/react/24/outline";

const NODE_STYLES = {
  trigger: { borderColor: "#98cf00", bg: "#f7fee7", iconColor: "#65a30d" },
  action: { borderColor: "#3b82f6", bg: "#eff6ff", iconColor: "#2563eb" },
  delay: { borderColor: "#f59e0b", bg: "#fffbeb", iconColor: "#d97706" },
  condition: { borderColor: "#8b5cf6", bg: "#f5f3ff", iconColor: "#7c3aed" },
};

const NODE_ICONS = {
  trigger: BoltIcon,
  action: EnvelopeIcon,
  delay: ClockIcon,
  condition: AdjustmentsHorizontalIcon,
};

const handleStyle = { visibility: "hidden" };

export const InboxWorkflowNode = ({ data }) => {
  const style = NODE_STYLES[data.nodeType] || NODE_STYLES.action;
  const Icon = NODE_ICONS[data.nodeType] || EnvelopeIcon;

  return (
    <div
      className="w-[280px] rounded-xl border-2 bg-white px-4 py-3 transition hover:shadow-md"
      style={{ borderColor: style.borderColor, backgroundColor: style.bg }}
    >
      {data.nodeType !== "trigger" && (
        <Handle type="target" position={Position.Top} style={handleStyle} />
      )}
      <Handle type="source" position={Position.Bottom} style={handleStyle} />

      <div className="flex items-center gap-2 mb-1.5">
        <div
          className="flex items-center justify-center w-6 h-6 rounded-md"
          style={{ backgroundColor: style.borderColor + "20" }}
        >
          <Icon className="w-3.5 h-3.5" style={{ color: style.iconColor }} />
        </div>
        <span className="text-sm font-semibold text-slate-900">
          {data.label}
        </span>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed pl-8">
        {data.description}
      </p>
    </div>
  );
};
